import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FooterWImageAndActionButtons from '../../../../components/footerwimageandactionbuttons/FooterWImageAndActionButtons';
import { HEADING } from '../../../../components/heading/constants/constants';
import Heading from '../../../../components/heading/Heading';
import { VEC_ICON_NAME } from '../../../../components/icons/constants';
import { componentKey, setIsYearFormTypeSelected, updateBatchImportFormData } from '../BatchImportSlice';
import { getFormsList } from '../BatchImportSaga';
import styles from './SelectYearFormType.styles';
import './directcss/CreateForm.scss';
import TextInput from '../../../../components/input/textinput/TextInput';
import Button from '../../../../components/button/Button';
import { BUTTON_TYPE } from '../../../../components/button/constants';
import Loadable from '../../../../components/loadable/Loadable';
import { BATCH_FORMS_LOADING_STATES, BATCH_FORM_STATES_MESSAGE_MAP } from '../constants';
import CardWTopLeftIcon from '../../../../components/card/CardWTopLeftIcon/CardWTopLeftIcon';
import RecommendForms from '../../../components/recommendform/RecommendForm';

export default function SelectYearFormType() {

    const [searchTerm, setSearchTerm] = useState('');
    const [selectedYearForms, setSelectedYearForms] = useState([])
    const [displayForms, setDisplayForms] = useState([])
    const [showFormRecommendation, setShowFormRecommendation] = useState(false)
    
    const dispatch = useDispatch();
    const { loadingState, formsList, batchImportFormData } = useSelector((state) => state[componentKey]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    useEffect(() => {
        dispatch(getFormsList());
    }, []);
    
    useEffect(() => {
        const formListOfYearTemp = formsList?.Forms && formsList.Forms.filter((forms) => {
            return forms.Year.includes(batchImportFormData.selectedYear);
        });
        setSelectedYearForms(formListOfYearTemp ?? []);
        setDisplayForms(formListOfYearTemp ?? []);
        setSearchTerm("");
    }, [batchImportFormData.selectedYear]);
    
    useEffect(() => {
        setDisplayForms((forms) => {
            const searchedFormList = selectedYearForms.filter((form) => {
                if(form.FormLabel.toLowerCase().includes(searchTerm.toLowerCase())){
                    return form
                }
            });
            if(searchedFormList){
                return searchedFormList;
            }else{
                return [];
            }
        })
    }, [searchTerm]);

    const handleFormSelect = (form) => {
        dispatch(updateBatchImportFormData({selectedForm: form}));
    }

    return <>
        <Loadable
            currentState={loadingState.state} 
            loadingStates={[BATCH_FORMS_LOADING_STATES.SELECT_YEAR_LOADING]} 
            messageMap={BATCH_FORM_STATES_MESSAGE_MAP}
            isNewLoadable={true}
        >
            <div style={styles.createFormContainer}>
                <div style={styles.bodyContainer}>
                    <div style={styles.headerRow}>
                        <Heading type={HEADING.H1}>
                            Select year and form type for which you want to import an excel spreadsheet
                        </Heading>
                    </div>
                    <div>Select Tax Year</div>
                    <div style={styles.yearSelectionRowContainer}>
                        <div style={styles.yearSelectionRow}>
                            {
                                formsList?.Years && formsList.Years.map((formYear) => {
                                    return <div onClick={() => dispatch(updateBatchImportFormData({ selectedYear: formYear }))} style={{ ...styles.yearBox, ...(batchImportFormData.selectedYear === formYear) ? styles.selectedYearBox : "" }} className={(batchImportFormData.selectedYear === formYear) ? "selectedYearBox" : ""} >
                                        {formYear}
                                    </div>
                                })
                            }
                        </div>
                        <div style={styles.recommendCardContainer}>
                            {batchImportFormData.selectedYear != null ? <CardWTopLeftIcon
                                topLeftIcon={{ icon: VEC_ICON_NAME.INFO_ICON, title: "" }}
                                title="Need help in finding a form ?"
                                linkButtonProps={{ label: "Tax form recommendation engine", onClickCb: ()=> setShowFormRecommendation(true) }}
                                subText="1099 forms can be confusing at times. However, we can provide the best recommendations based on your needs"
                            /> : null}
                        </div>
                    </div>
                    <div style={styles.searchRow}>
                        <TextInput
                            name="searchForm"
                            type="text"
                            value={searchTerm}
                            placeHolder='Search by form name...'
                            onChangeCb={handleSearchChange}
                            suffixProps={{ icon: VEC_ICON_NAME.SEARCH_ICON }}
                        />
                    </div>
                    <div style={styles.formSelectionRow}>
                        {   
                            batchImportFormData.selectedYear != null ?
                                (displayForms.length > 0 ? 
                                    displayForms.map((form) => {
                                        return <div onClick={() => handleFormSelect(form)} style={{...styles.formBox, ...(batchImportFormData?.selectedForm?.FormId && batchImportFormData.selectedForm.FormId === form.FormId) ? styles.selectedFormBox : ""}} >
                                            <Heading type={HEADING.H1} customStyle={styles.formNameStyles}>
                                                {form.FormLabel}
                                            </Heading>
                                            <Heading type={HEADING.H3} customStyle={styles.formBoxDesc}>
                                                {form.Desc}
                                            </Heading>
                                            {batchImportFormData.selectedForm && (batchImportFormData?.selectedForm?.FormId && batchImportFormData.selectedForm.FormId === form.FormId) ? <div style={{ ...styles.nextButtonDiv, ...styles.cardNextBtnDiv }}>
                                                <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => dispatch(setIsYearFormTypeSelected(true))}>Next</Button>
                                            </div> : null}
                                        </div>
                                    })
                                :   <p>No forms available for the selected year and the searched term</p>)
                            :   <p>Please select year to proceed</p>
                        }
                    </div>
                    {showFormRecommendation ? <RecommendForms formsList={formsList} userSelectedTaxYear={batchImportFormData.selectedYear} onClickFormFileCb={()=>dispatch(setIsYearFormTypeSelected(true))} userSelectedForm={batchImportFormData.selectedForm} handleFormSelectCb={handleFormSelect} onCloseCb={() => setShowFormRecommendation(false)} /> : null}
                </div>
                <div>
                    <FooterWImageAndActionButtons
                        nextButton={
                            batchImportFormData.selectedForm ? {
                                    text: "Next",
                                    clickCb: () => {dispatch(setIsYearFormTypeSelected(true))},
                                }
                            : {}
                        } 
                    >
                        {
                            (batchImportFormData?.selectedForm?.FormLabel) ? `Form: ${batchImportFormData.selectedForm.FormLabel} is selected` : null
                        }
                    </FooterWImageAndActionButtons>
                </div>
            </div>
        </Loadable>
    </>
}